import React, { useState } from 'react';
import JSZip from 'jszip';
import { useNavigate } from "react-router-dom";

import '../pages.scss';
import Snackbar from '../../components/snackbar.mjs';
import TopNavBar from '../../components/topNavBar.mjs';


const UserFiles = () => {
	const [userFileData, setUserFileData] = useState([]);
	const [unsortedUserFiles, setUnsortedUserFiles] = useState([]);
	const [hasSetup, setHasSetup] = useState(false);
	const [classList, setClassList] = useState([]);
	const [enrolledList, setEnrolledList] = useState([]);
	const [classDisplay, setClassDisplay] = useState('');
	const [classType, setClassType] = useState('');

	const [nameAscending, setNameAscending] = useState(true);
	const [fileNameAscending, setFileNameAscending] = useState(true);
	const [fileTypeAscending, setFileTypeAscending] = useState(true);
	const [dateAscending, setDateAscending] = useState(true);

	const navigate = useNavigate();

	const keygenID = sessionStorage.getItem('keygenID');
	const userToken = sessionStorage.getItem('userToken');
	const firstName = sessionStorage.getItem('firstName');
	const lastName = sessionStorage.getItem('lastName');

	const getOptions = {
		method: 'GET',
		cache: 'no-store'
	}

	const getClassList = async () => {
		var classCodes = [];

		await fetch("/getClassAssociation/?userID=" + keygenID + "&token=" + userToken, getOptions)
		.then(response => response.json())
		.then(async data => {
			if (data === "Not Authorized") {
				sessionStorage.clear();
				navigate("/");
				return;
			}

			if (data.Item === undefined) {
				return;
			}

			for (let i = 0; i < data.Item.Classes.L.length; i++) {
				var cls = [];
				var code = data.Item.Classes.L[i].S;
				cls.push(code);

				await fetch("/getClass/?userID=" + keygenID + "&token=" + userToken + "&classID=" + code, getOptions)
				.then(response => response.json())
				.then(data => {
					if (data === "Not Authorized") {
						sessionStorage.clear();
						navigate("/");
						return;
					}

					if (data.Item.ToDelete === undefined || data.Item.ToDelete.S === "") { // If the attribute doesn't exist or is empty
						cls.push(data.Item.ClassName.S);
						cls.push("Cloud");
						classCodes.push(cls);
					} else {
						console.log(data.Item.ClassName.S + " with code " + code + " has been marked for deletion.");
					}
				})
				.catch(error => {
					console.log(error);
					Snackbar("wentWrong", 10000);
				});
			}
		})
		.catch(error => {
			console.log(error);
			Snackbar("wentWrong", 10000);
		});

		await fetch("/getHardClassAssociation/?userID=" + keygenID + "&token=" + userToken, getOptions)
		.then(response => response.json())
		.then(async data => {
			if (data === "Not Authorized") {
				sessionStorage.clear();
				navigate("/");
				return;
			}

			if (data.Item === undefined) {
				return;
			}
			
			for (let k = 0; k < data.Item.Classes.L.length; k++) {
				var cls = [];
				var classid = data.Item.Classes.L[k].S;
				cls.push(classid);

				await fetch("/getHardClass/?userID=" + keygenID + "&token=" + userToken + "&classID=" + classid, getOptions)
				.then(response => response.json())
				.then(data => {
					if (data === "Not Authorized") {
						sessionStorage.clear();
						navigate("/");
						return;
					}

					if (data.Item.ToDelete === undefined || data.Item.ToDelete.S === "") { // If the attribute doesn't exist or is empty
						cls.push(data.Item.ClassName.S);
						cls.push("Hardware");
						classCodes.push(cls);
					} else {
						console.log(data.Item.ClassName.S + " with code " + classid + " has been marked for deletion.");
					}
				})
				.catch(error => {
					console.log(error);
					Snackbar("wentWrong", 10000);
				});
			}
		})
		.catch(error => {
			console.log(error);
			Snackbar("wentWrong", 10000);
		});

		return classCodes;
	}

	const getEnrollmentList = async (type) => {
		var enrollmentList = [];
		await fetch("/getCloudStuEnrollment/?userID=" + keygenID + "&token=" + userToken + "&type=" + type, getOptions)
		.then(response => response.json())
		.then(async data => {
			if (data === "Not Authorized") {
				sessionStorage.clear();
				navigate("/");
				return;
			}

			for (var i = 0; i < data.length; i++) {
				enrollmentList.push(data[i]);
			}
		})
		.catch(error => { 
			console.log(error);
			Snackbar("wentWrong", 10000);
		});

		await fetch("/getHardStuEnrollment/?userID=" + keygenID + "&token=" + userToken + "&type=" + type, getOptions)
		.then(response => response.json())
		.then(async data => {
			if (data === "Not Authorized") {
				sessionStorage.clear();
				navigate("/");
				return;
			}

			for (var i = 0; i < data.length; i++) {
				enrollmentList.push(data[i]);
			}
		})
		.catch(error => console.log(error));

		return enrollmentList;
	}

	if (!hasSetup) {
		fetch("/getUserType/?token=" + userToken + "&userID=" + keygenID, getOptions)
        .then(response => response.json())
		.then(async data => {
			if (data === "Not Authorized") {
				sessionStorage.clear();
				navigate("/");
				return;
			}

			if (data.Type === "Student") {
				setEnrolledList(await getEnrollmentList("Student"));
			} else if (data.Type === "Teacher") {
				setClassList(await getClassList());
			} else if (data.Type === "Scientist") { // Has credit quantity
				setEnrolledList(await getEnrollmentList("Scientist"));
				setClassList(await getClassList());
			}
			sessionStorage.setItem("userType", data.Type);
			setHasSetup(true);
			setUserFileData([["", "", "", "", ""]]);
			setUnsortedUserFiles([["", "", "", "", ""]]);
		})
		.catch(error => console.log(error));
	}

	const handleClassSelect = async (code, classType) => {
		setUserFileData([["", "", "", "", ""]]);
		setUnsortedUserFiles([["", "", "", "", ""]]);

		setClassType(classType);
		
		if (userType === "Teacher") {
			await fetch("/userFiles/?userID=" + keygenID + "&token=" + userToken + "&classID=" + code + "&userType=" + userType)
			.then(response => response.json())
			.then(async data => {
				if (data === "Not Authorized") {
					sessionStorage.clear();
					navigate("/");
					return;
				}

				if (data === undefined || data.length === 0) {
					setUserFileData([["", "", "", "", ""]]);
					setUnsortedUserFiles([["", "", "", "", ""]]);
				} else {
					var userID;
					var userName;
					for (var i = 0; i < data.length; i++) {
						var uid = data[i][0];
						var name = "";

						if (userID === undefined || userID !== uid) {
							userID = uid;
							await fetch("/getNameWithID/?userID=" + keygenID + "&token=" + userToken + "&uid=" + uid)
							.then(response => response.json())
							.then(nData => {
								if (nData === "Not Authorized") {
									sessionStorage.clear();
									navigate("/");
									return;
								}

								if (nData === "") {
									name = uid.substring(0, 20) + "...";
								} else {
									nData = nData.trim();
									const spaceIndex = nData.lastIndexOf(" ");
									const first = nData.substring(0, spaceIndex);
									name = nData.substring(spaceIndex) + ", " + first;
								}
							})
							userName = name;
						} else {
							name = userName;
						}
						
						data[i][1] = name;
					}

					setUserFileData(data);
					setUnsortedUserFiles(data);
				}
			})
			.catch(error => {
				console.log(error);
				Snackbar("wentWrong", 10000);
			});
		} else if (userType === "Student") {
			await fetch("/userFiles/?userID=" + keygenID + "&token=" + userToken + "&classID=" + code + "&userType=" + userType)
			.then(response => response.json())
			.then(data => {
				if (data === "Not Authorized") {
					sessionStorage.clear();
					navigate("/");
					return;
				}

				if (data === undefined || data.length === 0) {
					setUserFileData([["", "", "", "", ""]]);
					setUnsortedUserFiles([["", "", "", "", ""]]);
				} else {
					data.forEach((row) => {
						row[1] = firstName + " " + lastName;
					});

					setUserFileData(data);
					setUnsortedUserFiles(data);
				}
			})
			.catch(error => {
				console.log(error);
				Snackbar("wentWrong", 10000);
			});
		} else if (userType === "Scientist") {
			await fetch("/userFiles/?userID=" + keygenID + "&token=" + userToken + "&classID=" + code + "&userType=" + userType)
			.then(response => response.json())
			.then(async data => {
				if (data === "Not Authorized") {
					sessionStorage.clear();
					navigate("/");
					return;
				}

				if (data === undefined || data.length === 0) {
					setUserFileData([["", "", "", "", ""]]);
					setUnsortedUserFiles([["", "", "", "", ""]]);
				} else {
					var userID;
					var userName;
					for (var i = 0; i < data.length; i++) {
						var uid = data[i][0];
						var name = "";

						if (userID === undefined || userID !== uid) {
							userID = uid;
							await fetch("/getNameWithID/?userID=" + keygenID + "&token=" + userToken + "&uid=" + uid)
							.then(response => response.json())
							.then(nData => {
								if (nData === "Not Authorized") {
									sessionStorage.clear();
									navigate("/");
									return;
								}

								if (nData === "") {
									name = uid.substring(0, 20) + "...";
								} else {
									nData = nData.trim();
									const spaceIndex = nData.lastIndexOf(" ");
									const first = nData.substring(0, spaceIndex);
									name = nData.substring(spaceIndex) + ", " + first;
								}
							})
							userName = name;
						} else {
							name = userName;
						}
						
						data[i][1] = name;
					}

					setUserFileData(data);
					setUnsortedUserFiles(data);
				}
			})
			.catch(error => {
				console.log(error);
				Snackbar("wentWrong", 10000);
			});
		} else {
			Snackbar("wentWrong", 10000);
		}
		
		setHasSetup(true);
	}

	const handleSort = (targetIndex, ascend) => {	
		var sortedFileData = [...userFileData];	
		sortedFileData.forEach(row => {
			row.unshift(row[targetIndex].toLowerCase());
		});
		sortedFileData.sort();
		if (!ascend) {
			sortedFileData.reverse();
		}
		sortedFileData.forEach(row => {
			row.shift();
		});
		setUserFileData(sortedFileData);
	}

	const searchResult = (row, searchParam) => {
		return row.toString().toLowerCase().includes(searchParam.toLowerCase());
	}

	const handleSearch = (event) => {
		var searchParam = event.target.value;
		if (searchParam === "") {
			setUserFileData(unsortedUserFiles);
		} else {
			setTimeout(() => {
				var result = unsortedUserFiles.filter((row) => searchResult(row, searchParam));
				if (result.length === 0) {
					result.push(["", "", "", "", ""]);
				}
				setUserFileData(result);
			}, 350);
		}
	}

	const generateZip = async (zipObject, topLevelDirName) => {
		// Generate the zip file
		const zipFile = await zipObject.generateAsync({ type: 'blob' })

		// Download the zip by creating an anchor element and adding the click event
		const downloadLink = document.createElement('a');
		downloadLink.href = URL.createObjectURL(zipFile);
		downloadLink.download = topLevelDirName + ".zip";

		document.body.appendChild(downloadLink);
		downloadLink.click();

		setTimeout(() => {
			URL.revokeObjectURL(downloadLink.href);
			document.body.removeChild(downloadLink);
		}, 100);
	}

	const handleDownloadZip = () => {
		var toDownloadArray = [];
		var toDownloadKeys = [];
		var table = document.getElementById("userFileTable");
		var rowCollectionObjs = table.getElementsByClassName("row");
		var rowCollectionArray = [].slice.call(rowCollectionObjs);
	
		rowCollectionArray.forEach(rowCollectionObj => {
			if (rowCollectionObj.cells[0].firstChild.checked === true) {
				toDownloadKeys.push(Object.values(rowCollectionObj)[0].key);
			}
		});
		if (toDownloadKeys.length !== 0) {
			const zip = new JSZip();
			Snackbar("downloadStart", 10000);

			userFileData.forEach(row => {
				if (toDownloadKeys.includes(row[2])) {
					toDownloadArray.push(row);
				}
			});

			var counter = 0;
			toDownloadArray.forEach(row => {
				var key = classDisplay + "/" + row[0] + "/" + row[2];

				fetch("/downloadFromS3/?userID=" + keygenID + "&token=" + userToken + "&key=" + encodeURIComponent(key))
				.then(response => response.json())
				.then(data => {
					if (data === "Not Authorized") {
						sessionStorage.clear();
						navigate("/");
						return;
					}

					fetch(data)
					.then(async response => {
						try {
							if (response.status !== 200) {
								throw new Error(`Unable to download file. HTTP status: ${response.status}`);
							}
							const blob = await response.blob();
							var folder = zip.folder(row[1]);
							folder.file(row[2], blob);
							counter ++;
						} catch (error) {
							console.error('Error downloading the file:', error.message);
						}
					})
					.then(() => {
						if (counter === toDownloadArray.length) {
							generateZip(zip, "syGlassUserFiles");
						}
					});
				})
				.catch(error => {
					console.log(error);
					Snackbar("wentWrong", 10000);
				});
			})
		} else {
			Snackbar("noRowSelected", 10000);
		}
	}

	const handleSelectAllFiles = (checked) => {
		if (checked === true) {
			alert("You have selected ALL user files. Please be aware that syGlass files can be large and this process may take a while to finish.");
		}

		var allCheckbox = document.getElementById("allCheckbox");
		allCheckbox.checked = checked;

		var table = document.getElementById("userFileTable");
		var checkboxCollectionObjs = table.getElementsByClassName("rowCheckbox");
		for (let i = 0; i < checkboxCollectionObjs.length; i++) {
			checkboxCollectionObjs[i].checked = checked;
		}
	}

	const handleRowSelect = (rowChildrenHTMLCollection) => {
		var checkbox;
		if (rowChildrenHTMLCollection.length === 1) { // Clicked inside of checkbox, skip
			return;
		}

		checkbox = rowChildrenHTMLCollection[0].firstChild;
		checkbox.checked = !checkbox.checked;
	}

	var userType = sessionStorage.getItem("userType");

	var classesList;
	var classesEnrolledList;
	if (classList !== undefined && hasSetup && classList.length !== 0) {
		classesList = classList.map((clsArray) => 
			<option key={clsArray[0]} value={clsArray[0]} className={clsArray[2]}>{clsArray[1]}</option>
		);
	}

	if (enrolledList !== undefined && hasSetup && enrolledList.length !== 0) {
		classesEnrolledList = enrolledList.map((clsArray) => 
			<option key={clsArray[0]} value={clsArray[0]} className={clsArray[2]}>{clsArray[1]}</option>
		);
	}

	if (userFileData !== null && hasSetup) {
		var fileData = userFileData.map((row) =>
		<tr className={row[2] === "" ? "row placeholderRow" : "row"} key={row[2] === "" ? "placeholder" : row[2]} onClick={e => handleRowSelect(e.target.parentElement.children)}>
			<td style={{textAlign:'center'}} className="checkboxCell"><input type={row[2] === "" ? 'hidden' : 'checkbox'} className="rowCheckbox checkbox"/></td>
			<td key={Math.random().toString()}>{row[0]}</td>
			<td key={Math.random().toString()}>{row[1]}</td>
			<td key={row[2] === "" ? Math.random().toString() : row[2]} id={row[2]}>
				{
				(row[2] === "" || row[2].endsWith(".csv")) 
				? ""
				: (<div className="editIconDiv" onClick={(e) => handleEditFileName(e)}>
					<i className="editIcon">
						<span className="editIcon" class="material-symbols-outlined">
							edit
						</span>
					</i>
				</div>)
				} 
				{row[2].length < 52 ? row[2] : row[2].substring(0, 52) + "..."}
			</td>
			<td key={Math.random().toString()}>{row[3]}</td>
			<td key={Math.random().toString()}>{row[4]}</td>
		</tr>
    	);
	}

	const handleRefresh = () => {
		if (classDisplay.length > 0) {
			for (var i = 0; i < classList.length; i++) {
				if (classList[i][0] === classDisplay) {
					handleClassSelect(classDisplay, classList[i][2]);
				}
			}
		}
	}

	const handleSortName = () => {
		const nameIcon = document.getElementById("nameSort");
		nameIcon.classList.add("sortBorder");
		const fnameIcon = document.getElementById("fnameSort");
		fnameIcon.classList.remove("sortBorder");
		const ftypeIcon = document.getElementById("ftypeSort");
		ftypeIcon.classList.remove("sortBorder");
		const dateIcon = document.getElementById("dateSort");
		dateIcon.classList.remove("sortBorder");

		handleSort(1, nameAscending);
		setNameAscending(!nameAscending);
	}

	const handleSortFileName = () => {
		const nameIcon = document.getElementById("nameSort");
		nameIcon.classList.remove("sortBorder");
		const fnameIcon = document.getElementById("fnameSort");
		fnameIcon.classList.add("sortBorder");
		const ftypeIcon = document.getElementById("ftypeSort");
		ftypeIcon.classList.remove("sortBorder");
		const dateIcon = document.getElementById("dateSort");
		dateIcon.classList.remove("sortBorder");

		handleSort(2, fileNameAscending);
		setFileNameAscending(!fileNameAscending);
	}

	const handleSortFileType = () => {
		const nameIcon = document.getElementById("nameSort");
		nameIcon.classList.remove("sortBorder");
		const fnameIcon = document.getElementById("fnameSort");
		fnameIcon.classList.remove("sortBorder");
		const ftypeIcon = document.getElementById("ftypeSort");
		ftypeIcon.classList.add("sortBorder");
		const dateIcon = document.getElementById("dateSort");
		dateIcon.classList.remove("sortBorder");

		handleSort(3, fileTypeAscending);
		setFileTypeAscending(!fileTypeAscending);
	}

	const handleSortDateCreated = () => {
		const nameIcon = document.getElementById("nameSort");
		nameIcon.classList.remove("sortBorder");
		const fnameIcon = document.getElementById("fnameSort");
		fnameIcon.classList.remove("sortBorder");
		const ftypeIcon = document.getElementById("ftypeSort");
		ftypeIcon.classList.remove("sortBorder");
		const dateIcon = document.getElementById("dateSort");
		dateIcon.classList.add("sortBorder");

		handleSort(4, dateAscending);
		setDateAscending(!dateAscending);
	}

	const handleEditFileName = (e) => {
		var fNameCell = e.target.parentElement.parentElement.parentElement;
		if (fNameCell === undefined) {
			return;
		}

		var fileName = fNameCell.id;
		var oldExt = fileName.split(".")[1];
		var fileUserID = fNameCell.parentElement.children[1].innerText;
		if (oldExt === "syz" || oldExt === "syg" || oldExt === "syp" || oldExt === "sym" || oldExt === "syk" || oldExt === "syn") {
			Snackbar("renameSYFile", 10000);
			return;
		} else if (fileName === undefined || fileName === "" || fileUserID === undefined || fileUserID === "" || fileUserID === fileName) {
			Snackbar("wentWrong", 10000);
			return;
		} else if ((userType === "Student" && fileUserID !== keygenID) || fileName.toLowerCase() === "config.xml") {
			Snackbar("editPermissionDenied", 10000);
			return;
		}

		// Preserve existing cell
		var fileCell = document.getElementById(fileName);

		// Create the input field
		var newCell = document.createElement("td");
		var editInput = document.createElement("input");
		editInput.classList.add("renameInput");
		newCell.appendChild(editInput);

		// Swap cells to allow editing
		fileCell.replaceWith(newCell);
		editInput.focus();

		var regex = new RegExp(/^[a-zA-Z0-9!\-_*()\']+$/g)

		// Listen for "Enter" key press
		newCell.addEventListener("keyup", function(event) {
			event.preventDefault();
			if (event.keyCode === 13) {
				if (editInput.value === undefined || !regex.test(editInput.value.trim()) || editInput.value === "" || editInput.value === " ") {
					Snackbar("prohibitedChars", 10000);
					editInput.blur();
					return;
				}  else if (editInput.value.length > 40) {
					Snackbar("lengthCap", 10000);
					editInput.blur();
					return;
				} else if (editInput.value.toLowerCase() === "config") {
					Snackbar("forbiddenName", 10000);
					editInput.blur();
					return;
				}

				handleUpdateFileName(e, fileUserID, fileName, editInput.value + "." + oldExt)
				// Put new name in the name cell
				fileCell.innerText = editInput.value + "." + oldExt;
				try {
					newCell.replaceWith(fileCell);
					
				} catch (error) {
					console.log(error);
				}
			}
		});

		// Listen for unfocus event
		editInput.addEventListener("blur", function(event) { // Edit canceled
			event.preventDefault();
			// Swap back
			newCell.replaceWith(fileCell);
		});
	}

	const handleUpdateFileName = async (e, fileUserID, oldFileName, newFileName) => {
		if (classDisplay.length === 0) {
			return;
		}

		var classID = classDisplay;

		await fetch("/checkFileCollision/?userID=" + keygenID + "&token=" + userToken + "&classID=" + classID + "&fileName=" + newFileName)
		.then(response => response.json())
		.then(async data => {
			if (data === "Not Authorized") {
				sessionStorage.clear();
				navigate("/");
				return;
			}

			if (!data) {
				await fetch("/renameFile/?userID=" + keygenID + "&token=" + userToken + "&fileUser=" + fileUserID + "&classID=" + classID + "&oldFile=" + oldFileName + "&newFile=" + newFileName)
				.then(data => {
					if (data.json() === "Not Authorized") {
						sessionStorage.clear();
						navigate("/");
						return;
					}

					if (data.status !== 200) {
						Snackbar("wentWrong", 10000);
					}
				})
				.catch((error) => {
					console.log(error);
					Snackbar("wentWrong", 10000);
				});
			} else {
				Snackbar("fileExists", 10000);
			}
		});

		handleClassSelect(classDisplay, classType);
		handleSelectAllFiles(false);
	}


    return (
		<>
		<div>
			<TopNavBar></TopNavBar>
		</div>
		<div className="page" id="homePage">
			<div style={{height:'70px', width:'1120px', marginBottom:'50px'}}></div>

			<br></br>
			<div className="snackbarNormal" id="downloadStart">Downloading...</div>
			<div className="snackbarRed" id="wentWrong">Something went wrong. Please refresh and try again. If the problem persists, contact us for support</div>
			<div className="snackbarYellow" id="prohibitedChars">Type the new file name using the following characters: a-z, A-Z, 0-9, -, !, _, *, (, ), '</div>
			<div className="snackbarRed" id="renameSYFile">You may not change the names of syGlass files</div>
			<div className="snackbarYellow" id="fileExists">A file with that name already exists</div>
			<div className="snackbarRed" id="editPermissionDenied">You do not have permission to edit this file</div>
			<div className="snackbarYellow" id="lengthCap">The machine nickname must not exceed 40 characters in length</div>
			<div className="snackbarRed" id="forbiddenName">You may not use this name</div>
			<div className="snackbarYellow" id="noRowSelected">No files selected</div>

			<div className="userFileGrid">
				<div style={{width:'1120px'}}>
					<div style={{display:'inline-block', verticalAlign:'bottom'}}>
						<div style={userType !== "Student" ? {display:'flex', alignItems:'flex-start', marginBottom:'0px', width:'413px'} : {display:'none'}}>
							<p style={{marginRight:'10px', marginTop:'15px', marginBottom:'0px'}}>Managed classes:</p>
							<select id="classesDropdown" onChange={(e) => {setClassDisplay(e.target.value); handleClassSelect(e.target.value, e.target[e.target.selectedIndex].className);}} defaultValue={'DEFAULT'}>
								<option key="Select" value="DEFAULT" disabled>Select Class</option>
								{classesList}
							</select>
						</div>
						<div style={userType !== "Teacher" ? {display:'flex', alignItems:'flex-start', marginBottom:'0px', width:'413px'} : {display:'none'}}>
							<p style={{marginRight:'10px', marginTop:'15px', marginBottom:'15px'}}>Enrolled classes:</p>
							<select id="classesDropdown" onChange={(e) => {setClassDisplay(e.target.value); handleClassSelect(e.target.value, e.target[e.target.selectedIndex].className);}} defaultValue={'DEFAULT'}>
								<option key="Select" value="DEFAULT" disabled>Select Class</option>
								{classesEnrolledList}
							</select>
						</div>
					</div>

					<div style={{display:'inline-block', width:'30px', height:'30px', margin:'0px', padding:'0px', verticalAlign:'bottom'}} id="logoutIcon" onClick={handleRefresh}>
						<i style={{display:'inline-block'}}><span style={{display:'inline-block', fontSize:'30px', marginTop:'-5px'}} class="material-symbols-outlined">refresh</span></i>
					</div>

					<div style={{display:'inline-block', verticalAlign:'bottom', marginLeft:'375px'}}>
						<input type="text" id="fileSearchBar" name="searchParam" placeholder="Search" onChange={(event) => {
							handleSearch(event)}}/>
					</div>
				</div>

				<br></br>
				<div className="filesDiv tableDiv" style={{width: '1120px', height: '794px', overflowY: 'scroll', marginBottom:'13px', borderRadius:'5px', border:'0.5px solid #AFAFAF'}}>
					<table className="userFileTable" id="userFileTable">
						<tbody>
							<tr className="headers tableHeader">
								<th style={{textAlign:'center'}} className="checkboxCol"><input type="checkbox" className="checkbox" id="allCheckbox" onClick={(e) => {handleSelectAllFiles(e.target.checked)}}/></th>
								<th className="columnSort nameCol" onClick={handleSortName}>User Name <div id="nameSort" className=""><i className="sortIcon" style={{display: 'inline-block', marginBottom:'0px', marginTop:'0px', verticalAlign:'middle', width:'20px', height:'20px', marginRight:'0px'}}><span className="sortIcon" class="material-symbols-outlined">sort</span></i></div></th>
								<th className="columnSort fNameCol" onClick={handleSortFileName}>File Name <div id="fnameSort" className=""><i className="sortIcon" style={{display: 'inline-block', marginBottom:'0px', marginTop:'0px', verticalAlign:'middle', width:'20px', height:'20px', marginRight:'0px'}}><span className="sortIcon" class="material-symbols-outlined">sort</span></i></div></th>
								<th className="columnSort fTypeCol" onClick={handleSortFileType}>File Type <div id="ftypeSort" className=""><i className="sortIcon" style={{display: 'inline-block', marginBottom:'0px', marginTop:'0px', verticalAlign:'middle', width:'20px', height:'20px', marginRight:'0px'}}><span className="sortIcon" class="material-symbols-outlined">sort</span></i></div></th>
								<th className="columnSort dateCreatedCol" onClick={handleSortDateCreated}>Date Created <div id="dateSort" className=""><i className="sortIcon" style={{display: 'inline-block', marginBottom:'0px', marginTop:'0px', verticalAlign:'middle', width:'20px', height:'20px', marginRight:'0px'}}><span className="sortIcon" class="material-symbols-outlined">sort</span></i></div></th>
							</tr>
							{fileData}
						</tbody>
					</table>
				</div>
				<div style={{width:'181px', marginBottom:'100px'}}>
					<button className="btn" onClick={handleDownloadZip}>Download Selected</button>
				</div>
			</div>
		</div>
		</>
    );
}

export default UserFiles;
